module.exports = __webpack_public_path__ + "img/Manila-Bay-Clean-Up-Drive-1.214dc3c1.jpg";